import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation, HostListener } from '@angular/core';
import * as $ from 'jquery';

@Component({
  selector: 'app-cpp-marketing-program-tile-view',
  templateUrl: './cpp-marketing-program-tile-view.component.html',
  styleUrls: ['./cpp-marketing-program-tile-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CppMarketingProgramTileViewComponent implements OnInit {

  _tileViewDataSource: any[] = [];
  isDivVisible: boolean[][] = [];
  itemsToShow: number[][] = [];

  @Output() toggleFavoriteItems = new EventEmitter<any>();
  @Output() downloadProgramFile = new EventEmitter<any>();

  @Input()
  set tileViewDataSource(value: any[]) {
    this.onTileViewDataSourceChanged();
    this._tileViewDataSource = value || [];
  }

  get tileViewDataSource(): any[] {
    return this._tileViewDataSource;
  }




  @HostListener('window:resize', ['$event'])
  onresize(event) {
    this.setHeight();
  }

  ngAfterViewInit() {
    this.setHeight();
  }
  onTileViewDataSourceChanged() {
    this.isDivVisible = [];
    this.itemsToShow = [];
  }

  setHeight() {
    const templateHeight = window.innerHeight - 310;
    $('.tileView').css('max-height', templateHeight + 'px');
    $('.tileView').css('min-height', templateHeight - 2 + 'px');
  }

  toggleFavoriteItem(element: any) {
    this.toggleFavoriteItems.emit(element);
  }

  toggleDivVisibility(parentIndex: number, childIndex: number) {
    this.itemsToShow[parentIndex] = [];
    const isCurrentlyOpen = this.isDivVisible?.[parentIndex]?.[childIndex] ?? false;

    // Reset all divs to false (close all)
    this.isDivVisible = this.isDivVisible.map(row => row.map(() => false));

    // Ensure the parentIndex is initialized
    if (!this.isDivVisible[parentIndex]) {
      this.isDivVisible[parentIndex] = [];
    }

    // Toggle the clicked div: If it was open, close it; if it was closed, open it.
    this.isDivVisible[parentIndex][childIndex] = !isCurrentlyOpen;
  }

  setFavoriteProduct(itemID: number) {
    this.tileViewDataSource.forEach(tileView => {
      tileView.programGroupBy.forEach(programGroup => {
        programGroup.mpItems.forEach(item => {
          if (item.itemID === itemID) {
            item.isFavoriteProduct = true;
          }
        });
      });
    });
  }

  getVisibleItems(items: any[], parentIndex: number, childIndex: number): any[] {

    if (!this.itemsToShow[parentIndex]) {
      this.itemsToShow[parentIndex] = [];
    }
    const startIndex = this.itemsToShow[parentIndex][childIndex] || 0;

    if (items.length > 8) {
      return items.slice(startIndex, startIndex + 8);
    } else {
      return items;
    }

  }

  loadMoreItems(parentIndex: number, childIndex: number) {
    if (!this.itemsToShow[parentIndex]) {
      this.itemsToShow[parentIndex] = [];
    }
    if (!this.itemsToShow[parentIndex][childIndex]) {
      this.itemsToShow[parentIndex][childIndex] = 0;
    }
    this.itemsToShow[parentIndex][childIndex] += 8;
  }

  loadPreviousItems(parentIndex: number, childIndex: number) {
    if (!this.itemsToShow[parentIndex]) {
      this.itemsToShow[parentIndex] = [];
    }
    if (!this.itemsToShow[parentIndex][childIndex]) {
      this.itemsToShow[parentIndex][childIndex] = 0;
    }
    this.itemsToShow[parentIndex][childIndex] = Math.max(0, this.itemsToShow[parentIndex][childIndex] - 8);
  }

  hasMoreItems(items: any[], parentIndex: number, childIndex: number): boolean {
    if (!this.itemsToShow[parentIndex]) {
      this.itemsToShow[parentIndex] = [];
    }
    const startIndex = this.itemsToShow[parentIndex][childIndex] || 0;
    return startIndex + 8 < items.length;
  }

  hasPreviousItems(parentIndex: number, childIndex: number): boolean {
    if (!this.itemsToShow[parentIndex]) {
      this.itemsToShow[parentIndex] = [];
    }
    const startIndex = this.itemsToShow[parentIndex][childIndex] || 0;
    return startIndex > 0;
  }


  ngOnInit(): void {
    // Initialize isDivVisible and itemsToShow arrays based on the data structure
    this.tileViewDataSource.forEach((parent, parentIndex) => {
      this.isDivVisible[parentIndex] = [];
      this.itemsToShow[parentIndex] = [];
      parent.programGroupBy.forEach((child, childIndex) => {
        this.isDivVisible[parentIndex][childIndex] = false;
        this.itemsToShow[parentIndex][childIndex] = 0; // Initialize with 0 items to show
      });
    });
  }

  downloadFile(mediaObjectId) {
    this.downloadProgramFile.emit(mediaObjectId);
  }
}
